<template>
  <div class="bar" :class="curveClass" :style="barVars">
    <slot name="left-content">
      <div class="spacer"></div>
    </slot>
    <slot name="center-content">
      <div class="spacer"></div>
    </slot>
    <slot name="right-content">
      <div class="spacer"></div>
    </slot>
  </div>
</template>

<script>
export default {
  name: "CurvedBar",
  props: {
    direction: {
      type: String,
      default: "top",
      required: false,
    },
    curveFactorPc: {
      type: String,
      default: "15",
    },
  },
  computed: {
    barVars() {
      return {
        "--curve-factor-pc": `${this.curveFactorPc}%`,
      };
    },
    curveClass() {
      if (this.direction === "top") {
        return ["bar-top"];
      }

      return ["bar-bottom"];
    },
  },
};
</script>

<style lang="scss" scoped>
.bar {
  position: fixed;
  left: 0;
  right: 0;

  z-index: 2;
  display: flex;
  height: 80px;

  background: $brand-gradient;
}

.bar-top {
  top: 0;

  border-bottom-left-radius: 50% var(--curve-factor-pc);
  border-bottom-right-radius: 50% var(--curve-factor-pc);
}

.bar-bottom {
  bottom: 0;

  border-top-left-radius: 50% var(--curve-factor-pc);
  border-top-right-radius: 50% var(--curve-factor-pc);
}
</style>
